"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const FloatingComponent = ({ children, lockScroll = true, customContentHeight, customClass = '', customPortalElement, usePortal = true }) => {
    const ref = (0, react_1.useRef)(null);
    const childRef = (0, react_1.useRef)(null);
    const mainbody = document.querySelector('.main-body');
    const styledScrollbar = document.querySelectorAll('#styled-scrollbar');
    const [clientRect, setClientRect] = (0, react_1.useState)(null);
    const [top, setTop] = (0, react_1.useState)(null);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [horizontalAlign, setHorizontalAlign] = (0, react_1.useState)(null);
    const [verticalAlign, setVerticalAlign] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (lockScroll) {
            mainbody === null || mainbody === void 0 ? void 0 : mainbody.style.setProperty('overflow', 'hidden', 'important');
            for (let i = 0; i < styledScrollbar.length; i++) {
                styledScrollbar[i].style.setProperty('overflow', 'hidden', 'important');
            }
            return () => {
                if (mainbody)
                    mainbody.style.overflow = '';
                for (let i = 0; i < styledScrollbar.length; i++) {
                    styledScrollbar[i].style.overflow = '';
                }
            };
        }
        // eslint-disable-next-line
    }, []);
    const calculatePosition = (0, react_1.useCallback)(() => {
        var _a, _b, _c, _d, _e;
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const height = customContentHeight ||
            ((_b = (_a = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) ||
            0;
        const width = ((_d = (_c = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _c === void 0 ? void 0 : _c.firstElementChild) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().width) || 0;
        const rect = (_e = ref === null || ref === void 0 ? void 0 : ref.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect();
        setClientRect(rect || null);
        if (!rect)
            return;
        if (vw < (rect === null || rect === void 0 ? void 0 : rect.left) + width) {
            setHorizontalAlign('right');
        }
        if (vh < (rect === null || rect === void 0 ? void 0 : rect.top) + (rect === null || rect === void 0 ? void 0 : rect.height) + height) {
            setVerticalAlign('top');
        }
        else {
            setVerticalAlign('bottom');
        }
        setTop(rect === null || rect === void 0 ? void 0 : rect.top);
        setVisible(true);
    }, [childRef, customContentHeight]);
    (0, react_1.useEffect)(() => {
        if (ref && childRef) {
            calculatePosition();
        }
    }, [ref, childRef, calculatePosition]);
    return (react_1.default.createElement("div", { ref: ref, className: "absolute w-full h-full top-0 left-0 is-portal pointer-events-none" }, usePortal ? (react_1.default.createElement(FloatingPortal, { customClass: customClass, customPortalElement: customPortalElement, cssStyle: Object.assign({ position: 'fixed', left: clientRect === null || clientRect === void 0 ? void 0 : clientRect.left, zIndex: 1002, visibility: visible ? 'visible' : 'hidden', width: clientRect === null || clientRect === void 0 ? void 0 : clientRect.width, height: clientRect === null || clientRect === void 0 ? void 0 : clientRect.height, pointerEvents: 'none' }, (top && { top: top })) },
        react_1.default.createElement("div", { className: "pointer-events-auto", ref: childRef }, react_1.default.cloneElement(children, Object.assign(Object.assign({}, (horizontalAlign && {
            position: horizontalAlign
        })), (verticalAlign && { vPosition: verticalAlign })))))) : (react_1.default.createElement("div", { className: "pointer-events-auto", ref: childRef }, react_1.default.cloneElement(children, Object.assign(Object.assign({}, (horizontalAlign && {
        position: horizontalAlign
    })), (verticalAlign && { vPosition: verticalAlign })))))));
};
const FloatingPortal = ({ children, customClass, cssStyle, customPortalElement }) => {
    const sharedDropdown = customPortalElement || document.getElementById(`shared-dropdown`);
    return (sharedDropdown &&
        react_dom_1.default.createPortal(react_1.default.createElement("div", { id: 'floating-dropdown', className: customClass, style: cssStyle, onClick: (e) => {
                e.stopPropagation();
            } }, children), sharedDropdown));
};
exports.default = FloatingComponent;
